export const COLORS = {
  BEIGE: '#DFCDB7',
  BLANC: 'rgb(255, 255, 255)',
  WHITE: 'rgb(255, 255, 255)',
  AUTRE: `url(${process.env.REACT_APP_WYSIWYG_OCTIPAS_URL}/default-color-swatch.jpg) no-repeat center / contain`,
  OTHER: `url(${process.env.REACT_APP_WYSIWYG_OCTIPAS_URL}/default-color-swatch.jpg) no-repeat center / contain`,
  BLEU: 'rgb(90, 126, 202)',
  BLUE: 'rgb(90, 126, 202)',
  GRIS: '#A8AFB7',
  GREY: 'rgb(230, 230, 230)',
  JAUNE: 'rgb(255, 213, 17)',
  YELLOW: 'rgb(255, 213, 17)',
  MARRON: 'rgb(108, 73, 35)',
  BROWN: 'rgb(108, 73, 35)',
  NOIR: 'rgb(0, 0, 0)',
  BLACK: 'rgb(0, 0, 0)',
  ORANGE: 'rgb(229, 120, 46)',
  ROSE: 'rgb(246, 170, 183)',
  PINK: 'rgb(246, 170, 183)',
  ROUGE: 'rgb(194, 39, 11)',
  RED: 'rgb(194, 39, 11)',
  VERT: 'rgb(0, 165, 105)',
  GREEN: 'rgb(0, 165, 105)',
  VIOLET: 'rgb(128, 43, 172)',
  PURPLE: 'rgb(128, 43, 172)',
  ARGENTÉ: '#898886',
  SILVER: '#898886',
  CUIVRE: '#AB774A',
  COPPER: '#AB774A',
  DORÉ: '#A88531',
  GOLDEN: '#A88531',
};
